document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".career__item").forEach((item) => {
    const content = item.querySelector(".item__content");
    const heading = content?.querySelector("h6");

    if (heading && content.firstElementChild === heading) {
      item.insertBefore(heading, content);
    }
  });

  const items = document.querySelectorAll(".career__item button");

  items.forEach((button) => {
    button.addEventListener("click", () => {
      const container = button.parentElement;
      const isOpen = container.classList.contains("open");

      document.querySelectorAll(".career__item.open").forEach((openItem) => {
        openItem.classList.remove("open");
      });

      if (!isOpen) {
        container.classList.add("open");
      }
    });
  });
});
